// extracted by mini-css-extract-plugin
export default {"heading-space":"OverviewPage_heading-space__Tbt00","content-wrapper":"OverviewPage_content-wrapper__YRbvl"};